// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== PARENTAL CONTROL STYLES ====================
   All classes prefixed pc- to avoid collisions.
   ============================================================== */

   .pc-root { display: flex; flex-direction: column; gap: 0; }

   /* ── Master toggle ─────────────────────────────────────────────────────── */
   .pc-master-toggle {
     display: flex;
     align-items: center;
     justify-content: space-between;
     gap: 20px;
     padding: 18px 20px;
     background: rgba(255, 255, 255, 0.03);
     border: 1px solid rgba(255, 255, 255, 0.08);
     border-radius: 12px;
     margin-bottom: 24px;
   }
   
   .pc-master-toggle-info { display: flex; flex-direction: column; gap: 4px; }
   
   .pc-master-toggle-title {
     font-size: 14px;
     font-weight: 700;
     color: rgba(255, 255, 255, 0.88);
   }
   
   .pc-master-toggle-desc {
     font-size: 12.5px;
     color: rgba(255, 255, 255, 0.40);
     line-height: 1.55;
   }
   
   /* ── Inner tabs ────────────────────────────────────────────────────────── */
   .pc-inner-tabs {
     display: flex;
     flex-direction: row;
     gap: 0;
     border-bottom: 1px solid rgba(255, 255, 255, 0.08);
     margin-bottom: 24px;
     overflow-x: auto;
     scrollbar-width: none;
   }
   
   .pc-inner-tabs::-webkit-scrollbar { display: none; }
   
   .pc-inner-tab {
     flex-shrink: 0;
     background: transparent;
     border: none;
     border-bottom: 3px solid transparent;
     color: rgba(255, 255, 255, 0.40);
     font-size: 12.5px;
     font-weight: 600;
     padding: 10px 16px 8px;
     cursor: pointer;
     white-space: nowrap;
     transition: color 0.18s ease, border-bottom-color 0.18s ease;
   }
   
   .pc-inner-tab:hover { color: rgba(255, 255, 255, 0.75); }
   
   .pc-inner-tab--active {
     color: #fff !important;
     border-bottom-color: white;
     font-weight: 700;
   }
   
   /* ── Tab content ───────────────────────────────────────────────────────── */
   .pc-tab-content {
     animation: pc-fadeIn 0.18s ease;
   }
   
   @keyframes pc-fadeIn {
     from { opacity: 0; transform: translateY(5px); }
     to   { opacity: 1; transform: translateY(0);   }
   }
   
   /* ── Section wrapper ───────────────────────────────────────────────────── */
   .pc-section {
     background: rgba(36,36,45,0.2);
     border: 1px solid rgba(255, 255, 255, 0.07);
     border-radius: 12px;
     padding: 20px 22px;
     margin-bottom: 20px;
   }
   
   .pc-section-header {
     display: flex;
     align-items: flex-start;
     gap: 12px;
     margin-bottom: 18px;
     padding-bottom: 14px;
     border-bottom: 1px solid rgba(255, 255, 255, 0.06);
   }
   
   .pc-section-icon { font-size: 1.4rem; flex-shrink: 0; margin-top: 2px; }
   
   .pc-section-title {
     font-size: 14.5px;
     font-weight: 700;
     color: #fff;
     margin: 0 0 4px 0;
     padding: 0;
   }
   
   .pc-section-subtitle {
     font-size: 12px;
     color: rgba(255, 255, 255, 0.38);
     margin: 0;
     padding: 0;
     line-height: 1.6;
   }
   
   .pc-section-body { }
   
   /* ── Info banners ──────────────────────────────────────────────────────── */
   .pc-info-banner {
     display: flex;
     align-items: flex-start;
     gap: 10px;
     background: rgba(33, 150, 243, 0.08);
     border: 1px solid rgba(33, 150, 243, 0.20);
     border-radius: 9px;
     padding: 13px 16px;
     margin-bottom: 18px;
   }
   
   .pc-info-banner span { font-size: 1.1rem; flex-shrink: 0; margin-top: 1px; }
   
   .pc-info-banner p {
     font-size: 12.5px;
     color: rgba(255, 255, 255, 0.55);
     margin: 0;
     padding: 0;
     line-height: 1.65;
   }
   
   /* ── Form grid ─────────────────────────────────────────────────────────── */
   .pc-form-grid {
     display: grid;
     grid-template-columns: 1fr 1fr;
     gap: 0 24px;
   }
   
   .pc-form-row {
     display: flex;
     flex-direction: column;
     gap: 6px;
     margin-bottom: 18px;
   }
   
   .pc-form-label {
     font-size: 12px;
     font-weight: 700;
     text-transform: uppercase;
     letter-spacing: 0.05em;
     color: rgba(255, 255, 255, 0.50);
     display: flex;
     align-items: center;
     gap: 6px;
   }
   
   .pc-form-label-icon { font-size: 1rem; }
   
   .pc-input {
     background: rgba(255, 255, 255, 0.05);
     border: 1px solid gray;
     border-radius: 8px;
     color: #fff;
     font-size: 13.5px;
     padding: 10px 12px;
     outline: none;
     width: 100%;
     box-sizing: border-box;
     transition: border-color 0.18s ease, background 0.18s ease;
   }
   
   .pc-input:focus {
     background: rgba(76, 175, 80, 0.05);
   }
   
   .pc-form-complete-banner {
     padding: 12px 16px;
     background: rgba(76, 175, 80, 0.10);
     border: 1px solid rgba(76, 175, 80, 0.28);
     border-radius: 9px;
     color: #81c784;
     font-size: 13px;
     font-weight: 600;
     margin-top: 8px;
   }
   
   /* ── Profiles ──────────────────────────────────────────────────────────── */
   .pc-max-profiles-row {
     display: flex;
     align-items: center;
     justify-content: space-between;
     margin-bottom: 20px;
     padding: 14px 16px;
     background: rgba(255, 255, 255, 0.03);
     border: 1px solid rgba(255, 255, 255, 0.07);
     border-radius: 9px;
   }
   
   .pc-stepper {
     display: flex;
     align-items: center;
     gap: 0;
     border: 1px solid rgba(255, 255, 255, 0.12);
     border-radius: 8px;
     overflow: hidden;
   }
   
   .pc-stepper-btn {
     width: 34px;
     height: 34px;
     background: rgba(255, 255, 255, 0.06);
     border: none;
     color: rgba(255, 255, 255, 0.70);
     font-size: 18px;
     cursor: pointer;
     transition: background 0.15s ease;
     display: flex;
     align-items: center;
     justify-content: center;
   }
   
   .pc-stepper-btn:hover:not(:disabled) { background: rgba(76, 175, 80, 0.18); color: #4caf50; }
   .pc-stepper-btn:disabled { opacity: 0.30; cursor: not-allowed; }
   
   .pc-stepper-val {
     min-width: 38px;
     text-align: center;
     font-size: 16px;
     font-weight: 700;
     color: #fff;
     background: rgba(255, 255, 255, 0.03);
     height: 34px;
     display: flex;
     align-items: center;
     justify-content: center;
   }
   
   .pc-badge {
     display: inline-block;
     font-size: 11px;
     padding: 2px 8px;
     border-radius: 20px;
     background: rgba(76, 175, 80, 0.15);
     border: 1px solid rgba(76, 175, 80, 0.30);
     color: #81c784;
     font-weight: 700;
     margin-left: 8px;
     text-transform: none;
     letter-spacing: 0;
   }
   
   .pc-profile-chips {
     display: flex;
     flex-wrap: wrap;
     gap: 10px;
     margin-bottom: 16px;
   }
   
   .pc-profile-chip {
     display: flex;
     align-items: center;
     gap: 6px;
     padding: 9px 16px;
     background: rgba(255, 255, 255, 0.04);
     border: 1px solid rgba(255, 255, 255, 0.10);
     border-radius: 24px;
     color: rgba(255, 255, 255, 0.70);
     font-size: 13px;
     font-weight: 600;
     cursor: pointer;
     transition: all 0.18s ease;
   }
   
   .pc-profile-chip:hover:not(.pc-profile-chip--disabled) {
     background: rgba(76, 175, 80, 0.12);
     border-color: rgba(76, 175, 80, 0.40);
     color: #81c784;
   }
   
   .pc-profile-chip--added {
     background: rgba(76, 175, 80, 0.15) !important;
     border-color: rgba(76, 175, 80, 0.40) !important;
     color: #81c784 !important;
   }
   
   .pc-profile-chip--disabled { opacity: 0.35; cursor: not-allowed; }
   .pc-chip-remove { margin-left: 4px; font-size: 15px; opacity: 0.7; }
   
   .pc-selected-profiles { margin-top: 12px; }
   
   .pc-selected-profiles-list {
     display: flex;
     flex-wrap: wrap;
     gap: 8px;
     margin-top: 8px;
   }
   
   .pc-selected-profile-tag {
     display: flex;
     align-items: center;
     gap: 6px;
     background: rgba(76, 175, 80, 0.12);
     border: 1px solid rgba(76, 175, 80, 0.28);
     border-radius: 8px;
     padding: 7px 12px;
     font-size: 12.5px;
     color: #81c784;
     font-weight: 600;
   }
   
   .pc-remove-profile-btn {
     background: none;
     border: none;
     color: rgba(255, 255, 255, 0.40);
     font-size: 16px;
     cursor: pointer;
     padding: 0 0 0 4px;
     line-height: 1;
     transition: color 0.15s ease;
   }
   
   .pc-remove-profile-btn:hover { color: #f44336; }
   
   /* ── Radio cards ───────────────────────────────────────────────────────── */
   .pc-radio-group {
     display: flex;
     flex-direction: column;
     gap: 10px;
   }
   
   .pc-radio-card {
     display: flex;
     align-items: center;
     gap: 14px;
     padding: 14px 16px;
     background: rgba(255, 255, 255, 0.02);
     border: 1px solid rgba(255, 255, 255, 0.08);
     border-radius: 10px;
     cursor: pointer;
     transition: all 0.18s ease;
     width: 100%;
     box-sizing: border-box;
     text-align: left;
   }
   
   .pc-radio-card:hover { border-color: rgba(76, 175, 80, 0.35); background: rgba(76, 175, 80, 0.04); }
   
   .pc-radio-card--selected {
     border-color: rgba(76, 175, 80, 0.40) !important;
     background: rgba(76, 175, 80, 0.07) !important;
   }
   
   .pc-radio-card-icon { font-size: 1.4rem; flex-shrink: 0; width: 28px; text-align: center; }
   
   .pc-radio-card-info { flex: 1 1; display: flex; flex-direction: column; gap: 3px; }
   
   .pc-radio-card-label { font-size: 13.5px; font-weight: 700; color: rgba(255, 255, 255, 0.88); }
   .pc-radio-card-desc  { font-size: 12px; color: rgba(255, 255, 255, 0.38); line-height: 1.5; }
   
   .pc-radio-dot {
     width: 18px;
     height: 18px;
     border-radius: 50%;
     border: 2px solid rgba(255, 255, 255, 0.22);
     flex-shrink: 0;
     transition: background 0.18s ease, border-color 0.18s ease;
   }
   
   /* ── Toggle rows ───────────────────────────────────────────────────────── */
   .pc-toggle-row {
     display: flex;
     align-items: center;
     gap: 14px;
     padding: 14px 0;
     border-bottom: 1px solid rgba(255, 255, 255, 0.05);
   }
   
   .pc-toggle-row--disabled { opacity: 0.45; }
   
   .pc-toggle-icon { font-size: 1.3rem; flex-shrink: 0; width: 28px; text-align: center; }
   
   .pc-toggle-info { flex: 1 1; display: flex; flex-direction: column; gap: 3px; }
   
   .pc-toggle-label { font-size: 13.5px; font-weight: 600; color: rgba(255, 255, 255, 0.82); }
   .pc-toggle-desc  { font-size: 12px; color: rgba(255, 255, 255, 0.36); line-height: 1.5; }
   
   .pc-filter-grid, .pc-perms-grid { display: flex; flex-direction: column; }
   
   .pc-switch--disabled { cursor: not-allowed; opacity: 0.50; }
   
   /* ── Subscription warning ──────────────────────────────────────────────── */
   .pc-subscription-warning {
     display: flex;
     align-items: flex-start;
     gap: 14px;
     background: rgba(244, 67, 54, 0.08);
     border: 1px solid rgba(244, 67, 54, 0.22);
     border-radius: 10px;
     padding: 16px 18px;
     margin-top: 20px;
   }
   
   .pc-sub-warn-icon { font-size: 1.8rem; flex-shrink: 0; }
   
   .pc-sub-warn-title {
     font-size: 13.5px;
     font-weight: 700;
     color: #ef9a9a;
     margin: 0 0 5px 0;
     padding: 0;
   }
   
   .pc-sub-warn-desc {
     font-size: 12px;
     color: rgba(255, 255, 255, 0.45);
     margin: 0;
     padding: 0;
     line-height: 1.65;
   }
   
   /* ── Created accounts list ─────────────────────────────────────────────── */
   .pc-empty-accounts {
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 10px;
     padding: 40px 20px;
     color: rgba(255, 255, 255, 0.38);
     font-size: 14px;
   }
   
   .pc-accounts-list {
     display: flex;
     flex-direction: column;
     gap: 16px;
   }
   
   .pc-account-card {
     background: rgba(255, 255, 255, 0.025);
     border: 1px solid rgba(255, 255, 255, 0.08);
     border-radius: 12px;
     overflow: hidden;
   }
   
   .pc-account-card-header {
     display: flex;
     align-items: center;
     gap: 12px;
     padding: 14px 18px;
     background: rgba(76, 175, 80, 0.06);
     border-bottom: 1px solid rgba(255, 255, 255, 0.06);
   }
   
   .pc-account-avatar { font-size: 1.8rem; flex-shrink: 0; }
   
   .pc-account-card-info { flex: 1 1; display: flex; flex-direction: column; gap: 2px; }
   
   .pc-account-name { font-size: 14px; font-weight: 700; color: #fff; }
   .pc-account-uid  { font-size: 12px; color: rgba(255, 255, 255, 0.42); font-family: monospace; }
   
   .pc-account-linked-badge {
     font-size: 11px;
     font-weight: 700;
     padding: 4px 10px;
     border-radius: 20px;
     background: rgba(76, 175, 80, 0.14);
     border: 1px solid rgba(76, 175, 80, 0.28);
     color: #81c784;
   }
   
   .pc-account-card-details {
     padding: 14px 18px;
     display: flex;
     flex-direction: column;
     gap: 8px;
   }
   
   .pc-account-detail-row {
     display: flex;
     align-items: center;
     gap: 12px;
     font-size: 13px;
   }
   
   .pc-detail-key {
     min-width: 130px;
     color: rgba(255, 255, 255, 0.40);
     font-size: 12px;
     font-weight: 600;
   }
   
   .pc-detail-val { color: rgba(255, 255, 255, 0.75); font-size: 12.5px; }
   
   .pc-account-login-hint {
     display: flex;
     align-items: center;
     gap: 8px;
     padding: 10px 18px;
     background: rgba(33, 150, 243, 0.07);
     border-top: 1px solid rgba(33, 150, 243, 0.15);
     font-size: 12px;
     color: rgba(255, 255, 255, 0.50);
   }
   
   .pc-account-login-hint strong { color: #64b5f6; font-family: monospace; }
   
   /* ── Toast ─────────────────────────────────────────────────────────────── */
   .pc-toast {
     display: flex;
     align-items: flex-start;
     justify-content: space-between;
     gap: 12px;
     padding: 13px 18px;
     border-radius: 10px;
     font-size: 13.5px;
     font-weight: 600;
     margin-bottom: 20px;
     animation: pc-fadeIn 0.2s ease;
   }
   
   .pc-toast--success { background: rgba(76,175,80,0.12); border: 1px solid rgba(76,175,80,0.30); color: #81c784; }
   .pc-toast--warning { background: rgba(255,152,0,0.10); border: 1px solid rgba(255,152,0,0.28); color: #ffb74d; }
   .pc-toast--error   { background: rgba(244,67,54,0.10); border: 1px solid rgba(244,67,54,0.28); color: #ef9a9a; }
   
   .pc-toast-close {
     background: none;
     border: none;
     color: inherit;
     opacity: 0.6;
     font-size: 20px;
     cursor: pointer;
     line-height: 1;
     flex-shrink: 0;
   }
   
   /* ── Action bar ────────────────────────────────────────────────────────── */
   .pc-action-bar {
     display: flex;
     align-items: center;
     gap: 12px;
     padding-top: 20px;
     margin-top: 8px;
     border-top: 1px solid rgba(255, 255, 255, 0.07);
   }
   
   .pc-reset-btn {
     background: black;
     border: 1px solid rgba(255, 255, 255, 0.10);
     color: white;
     border-radius: 9px;
     padding: 11px 22px;
     font-size: 13px;
     font-weight: 700;
     cursor: pointer;
     transition: background 0.15s ease;
   }
   
   .pc-reset-btn:hover { background: rgba(255, 255, 255, 0.10); color: rgba(255,255,255,0.80); }
   
   .pc-submit-btn { align-self: flex-start; }
   
   /* ── Responsive ────────────────────────────────────────────────────────── */
   @media (max-width: 768px) {
     .pc-form-grid       { grid-template-columns: 1fr; }
     .pc-inner-tab       { font-size: 11.5px; padding: 9px 11px; }
     .pc-action-bar      { flex-direction: column; align-items: stretch; }
     .pc-reset-btn,
     .pc-submit-btn      { width: 100%; text-align: center; }
     .pc-master-toggle   { flex-direction: column; align-items: flex-start; }
   }
   `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/ParentalControl.css"],"names":[],"mappings":"AAAA;;mEAEmE;;GAEhE,WAAW,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;;GAE1D,6EAA6E;GAC7E;KACE,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,SAAS;KACT,kBAAkB;KAClB,qCAAqC;KACrC,2CAA2C;KAC3C,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;GAE1E;KACE,eAAe;KACf,gBAAgB;KAChB,gCAAgC;GAClC;;GAEA;KACE,iBAAiB;KACjB,gCAAgC;KAChC,iBAAiB;GACnB;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,mBAAmB;KACnB,MAAM;KACN,kDAAkD;KAClD,mBAAmB;KACnB,gBAAgB;KAChB,qBAAqB;GACvB;;GAEA,oCAAoC,aAAa,EAAE;;GAEnD;KACE,cAAc;KACd,uBAAuB;KACvB,YAAY;KACZ,oCAAoC;KACpC,gCAAgC;KAChC,iBAAiB;KACjB,gBAAgB;KAChB,sBAAsB;KACtB,eAAe;KACf,mBAAmB;KACnB,4DAA4D;GAC9D;;GAEA,sBAAsB,gCAAgC,EAAE;;GAExD;KACE,sBAAsB;KACtB,0BAA0B;KAC1B,gBAAgB;GAClB;;GAEA,6EAA6E;GAC7E;KACE,+BAA+B;GACjC;;GAEA;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;GACjD;;GAEA,6EAA6E;GAC7E;KACE,8BAA8B;KAC9B,2CAA2C;KAC3C,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,mBAAmB;KACnB,oBAAoB;KACpB,kDAAkD;GACpD;;GAEA,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;GAEvE;KACE,iBAAiB;KACjB,gBAAgB;KAChB,WAAW;KACX,iBAAiB;KACjB,UAAU;GACZ;;GAEA;KACE,eAAe;KACf,gCAAgC;KAChC,SAAS;KACT,UAAU;KACV,gBAAgB;GAClB;;GAEA,mBAAmB;;GAEnB,6EAA6E;GAC7E;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,oCAAoC;KACpC,0CAA0C;KAC1C,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;GAE3E;KACE,iBAAiB;KACjB,gCAAgC;KAChC,SAAS;KACT,UAAU;KACV,iBAAiB;GACnB;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,8BAA8B;KAC9B,WAAW;GACb;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,yBAAyB;KACzB,sBAAsB;KACtB,gCAAgC;KAChC,aAAa;KACb,mBAAmB;KACnB,QAAQ;GACV;;GAEA,sBAAsB,eAAe,EAAE;;GAEvC;KACE,qCAAqC;KACrC,sBAAsB;KACtB,kBAAkB;KAClB,WAAW;KACX,iBAAiB;KACjB,kBAAkB;KAClB,aAAa;KACb,WAAW;KACX,sBAAsB;KACtB,0DAA0D;GAC5D;;GAEA;KACE,mCAAmC;GACrC;;GAEA;KACE,kBAAkB;KAClB,mCAAmC;KACnC,yCAAyC;KACzC,kBAAkB;KAClB,cAAc;KACd,eAAe;KACf,gBAAgB;KAChB,eAAe;GACjB;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,mBAAmB;KACnB,kBAAkB;KAClB,qCAAqC;KACrC,2CAA2C;KAC3C,kBAAkB;GACpB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,MAAM;KACN,2CAA2C;KAC3C,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,qCAAqC;KACrC,YAAY;KACZ,gCAAgC;KAChC,eAAe;KACf,eAAe;KACf,iCAAiC;KACjC,aAAa;KACb,mBAAmB;KACnB,uBAAuB;GACzB;;GAEA,uCAAuC,mCAAmC,EAAE,cAAc,EAAE;GAC5F,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;;GAE/D;KACE,eAAe;KACf,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,WAAW;KACX,qCAAqC;KACrC,YAAY;KACZ,aAAa;KACb,mBAAmB;KACnB,uBAAuB;GACzB;;GAEA;KACE,qBAAqB;KACrB,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,mCAAmC;KACnC,yCAAyC;KACzC,cAAc;KACd,gBAAgB;KAChB,gBAAgB;KAChB,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA;KACE,aAAa;KACb,eAAe;KACf,SAAS;KACT,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,iBAAiB;KACjB,qCAAqC;KACrC,2CAA2C;KAC3C,mBAAmB;KACnB,gCAAgC;KAChC,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,0BAA0B;GAC5B;;GAEA;KACE,mCAAmC;KACnC,qCAAqC;KACrC,cAAc;GAChB;;GAEA;KACE,8CAA8C;KAC9C,gDAAgD;KAChD,yBAAyB;GAC3B;;GAEA,6BAA6B,aAAa,EAAE,mBAAmB,EAAE;GACjE,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,YAAY,EAAE;;GAEnE,wBAAwB,gBAAgB,EAAE;;GAE1C;KACE,aAAa;KACb,eAAe;KACf,QAAQ;KACR,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,mCAAmC;KACnC,yCAAyC;KACzC,kBAAkB;KAClB,iBAAiB;KACjB,iBAAiB;KACjB,cAAc;KACd,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;KAChB,YAAY;KACZ,gCAAgC;KAChC,eAAe;KACf,eAAe;KACf,kBAAkB;KAClB,cAAc;KACd,4BAA4B;GAC9B;;GAEA,+BAA+B,cAAc,EAAE;;GAE/C,6EAA6E;GAC7E;KACE,aAAa;KACb,sBAAsB;KACtB,SAAS;GACX;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,kBAAkB;KAClB,qCAAqC;KACrC,2CAA2C;KAC3C,mBAAmB;KACnB,eAAe;KACf,0BAA0B;KAC1B,WAAW;KACX,sBAAsB;KACtB,gBAAgB;GAClB;;GAEA,uBAAuB,qCAAqC,EAAE,mCAAmC,EAAE;;GAEnG;KACE,gDAAgD;KAChD,8CAA8C;GAChD;;GAEA,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;;GAE1F,sBAAsB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;GAEhF,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE;GAC9F,uBAAuB,eAAe,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;;GAE5F;KACE,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,2CAA2C;KAC3C,cAAc;KACd,0DAA0D;GAC5D;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,eAAe;KACf,kDAAkD;GACpD;;GAEA,2BAA2B,aAAa,EAAE;;GAE1C,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;;GAEtF,kBAAkB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;GAE5E,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE;GAC1F,mBAAmB,eAAe,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;;GAExF,kCAAkC,aAAa,EAAE,sBAAsB,EAAE;;GAEzE,uBAAuB,mBAAmB,EAAE,aAAa,EAAE;;GAE3D,6EAA6E;GAC7E;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,mCAAmC;KACnC,yCAAyC;KACzC,mBAAmB;KACnB,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;;GAEvD;KACE,iBAAiB;KACjB,gBAAgB;KAChB,cAAc;KACd,iBAAiB;KACjB,UAAU;GACZ;;GAEA;KACE,eAAe;KACf,gCAAgC;KAChC,SAAS;KACT,UAAU;KACV,iBAAiB;GACnB;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,SAAS;KACT,kBAAkB;KAClB,gCAAgC;KAChC,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,SAAS;GACX;;GAEA;KACE,sCAAsC;KACtC,2CAA2C;KAC3C,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,kBAAkB;KAClB,mCAAmC;KACnC,kDAAkD;GACpD;;GAEA,qBAAqB,iBAAiB,EAAE,cAAc,EAAE;;GAExD,wBAAwB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;GAElF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;GACnE,mBAAmB,eAAe,EAAE,gCAAgC,EAAE,sBAAsB,EAAE;;GAE9F;KACE,eAAe;KACf,gBAAgB;KAChB,iBAAiB;KACjB,mBAAmB;KACnB,mCAAmC;KACnC,yCAAyC;KACzC,cAAc;GAChB;;GAEA;KACE,kBAAkB;KAClB,aAAa;KACb,sBAAsB;KACtB,QAAQ;GACV;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,eAAe;GACjB;;GAEA;KACE,gBAAgB;KAChB,gCAAgC;KAChC,eAAe;KACf,gBAAgB;GAClB;;GAEA,iBAAiB,gCAAgC,EAAE,iBAAiB,EAAE;;GAEtE;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,kBAAkB;KAClB,oCAAoC;KACpC,8CAA8C;KAC9C,eAAe;KACf,gCAAgC;GAClC;;GAEA,gCAAgC,cAAc,EAAE,sBAAsB,EAAE;;GAExE,6EAA6E;GAC7E;KACE,aAAa;KACb,uBAAuB;KACvB,8BAA8B;KAC9B,SAAS;KACT,kBAAkB;KAClB,mBAAmB;KACnB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;KACnB,8BAA8B;GAChC;;GAEA,qBAAqB,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE;GAC/G,qBAAqB,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE;GAC/G,qBAAqB,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE;;GAE/G;KACE,gBAAgB;KAChB,YAAY;KACZ,cAAc;KACd,YAAY;KACZ,eAAe;KACf,eAAe;KACf,cAAc;KACd,cAAc;GAChB;;GAEA,6EAA6E;GAC7E;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,iBAAiB;KACjB,eAAe;KACf,+CAA+C;GACjD;;GAEA;KACE,iBAAiB;KACjB,2CAA2C;KAC3C,YAAY;KACZ,kBAAkB;KAClB,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,iCAAiC;GACnC;;GAEA,sBAAsB,qCAAqC,EAAE,6BAA6B,EAAE;;GAE5F,iBAAiB,sBAAsB,EAAE;;GAEzC,6EAA6E;GAC7E;KACE,sBAAsB,0BAA0B,EAAE;KAClD,sBAAsB,iBAAiB,EAAE,iBAAiB,EAAE;KAC5D,sBAAsB,sBAAsB,EAAE,oBAAoB,EAAE;KACpE;2BACsB,WAAW,EAAE,kBAAkB,EAAE;KACvD,sBAAsB,sBAAsB,EAAE,uBAAuB,EAAE;GACzE","sourcesContent":["/* ==================== PARENTAL CONTROL STYLES ====================\n   All classes prefixed pc- to avoid collisions.\n   ============================================================== */\n\n   .pc-root { display: flex; flex-direction: column; gap: 0; }\n\n   /* ── Master toggle ─────────────────────────────────────────────────────── */\n   .pc-master-toggle {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     gap: 20px;\n     padding: 18px 20px;\n     background: rgba(255, 255, 255, 0.03);\n     border: 1px solid rgba(255, 255, 255, 0.08);\n     border-radius: 12px;\n     margin-bottom: 24px;\n   }\n   \n   .pc-master-toggle-info { display: flex; flex-direction: column; gap: 4px; }\n   \n   .pc-master-toggle-title {\n     font-size: 14px;\n     font-weight: 700;\n     color: rgba(255, 255, 255, 0.88);\n   }\n   \n   .pc-master-toggle-desc {\n     font-size: 12.5px;\n     color: rgba(255, 255, 255, 0.40);\n     line-height: 1.55;\n   }\n   \n   /* ── Inner tabs ────────────────────────────────────────────────────────── */\n   .pc-inner-tabs {\n     display: flex;\n     flex-direction: row;\n     gap: 0;\n     border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n     margin-bottom: 24px;\n     overflow-x: auto;\n     scrollbar-width: none;\n   }\n   \n   .pc-inner-tabs::-webkit-scrollbar { display: none; }\n   \n   .pc-inner-tab {\n     flex-shrink: 0;\n     background: transparent;\n     border: none;\n     border-bottom: 3px solid transparent;\n     color: rgba(255, 255, 255, 0.40);\n     font-size: 12.5px;\n     font-weight: 600;\n     padding: 10px 16px 8px;\n     cursor: pointer;\n     white-space: nowrap;\n     transition: color 0.18s ease, border-bottom-color 0.18s ease;\n   }\n   \n   .pc-inner-tab:hover { color: rgba(255, 255, 255, 0.75); }\n   \n   .pc-inner-tab--active {\n     color: #fff !important;\n     border-bottom-color: white;\n     font-weight: 700;\n   }\n   \n   /* ── Tab content ───────────────────────────────────────────────────────── */\n   .pc-tab-content {\n     animation: pc-fadeIn 0.18s ease;\n   }\n   \n   @keyframes pc-fadeIn {\n     from { opacity: 0; transform: translateY(5px); }\n     to   { opacity: 1; transform: translateY(0);   }\n   }\n   \n   /* ── Section wrapper ───────────────────────────────────────────────────── */\n   .pc-section {\n     background: rgba(36,36,45,0.2);\n     border: 1px solid rgba(255, 255, 255, 0.07);\n     border-radius: 12px;\n     padding: 20px 22px;\n     margin-bottom: 20px;\n   }\n   \n   .pc-section-header {\n     display: flex;\n     align-items: flex-start;\n     gap: 12px;\n     margin-bottom: 18px;\n     padding-bottom: 14px;\n     border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n   }\n   \n   .pc-section-icon { font-size: 1.4rem; flex-shrink: 0; margin-top: 2px; }\n   \n   .pc-section-title {\n     font-size: 14.5px;\n     font-weight: 700;\n     color: #fff;\n     margin: 0 0 4px 0;\n     padding: 0;\n   }\n   \n   .pc-section-subtitle {\n     font-size: 12px;\n     color: rgba(255, 255, 255, 0.38);\n     margin: 0;\n     padding: 0;\n     line-height: 1.6;\n   }\n   \n   .pc-section-body { }\n   \n   /* ── Info banners ──────────────────────────────────────────────────────── */\n   .pc-info-banner {\n     display: flex;\n     align-items: flex-start;\n     gap: 10px;\n     background: rgba(33, 150, 243, 0.08);\n     border: 1px solid rgba(33, 150, 243, 0.20);\n     border-radius: 9px;\n     padding: 13px 16px;\n     margin-bottom: 18px;\n   }\n   \n   .pc-info-banner span { font-size: 1.1rem; flex-shrink: 0; margin-top: 1px; }\n   \n   .pc-info-banner p {\n     font-size: 12.5px;\n     color: rgba(255, 255, 255, 0.55);\n     margin: 0;\n     padding: 0;\n     line-height: 1.65;\n   }\n   \n   /* ── Form grid ─────────────────────────────────────────────────────────── */\n   .pc-form-grid {\n     display: grid;\n     grid-template-columns: 1fr 1fr;\n     gap: 0 24px;\n   }\n   \n   .pc-form-row {\n     display: flex;\n     flex-direction: column;\n     gap: 6px;\n     margin-bottom: 18px;\n   }\n   \n   .pc-form-label {\n     font-size: 12px;\n     font-weight: 700;\n     text-transform: uppercase;\n     letter-spacing: 0.05em;\n     color: rgba(255, 255, 255, 0.50);\n     display: flex;\n     align-items: center;\n     gap: 6px;\n   }\n   \n   .pc-form-label-icon { font-size: 1rem; }\n   \n   .pc-input {\n     background: rgba(255, 255, 255, 0.05);\n     border: 1px solid gray;\n     border-radius: 8px;\n     color: #fff;\n     font-size: 13.5px;\n     padding: 10px 12px;\n     outline: none;\n     width: 100%;\n     box-sizing: border-box;\n     transition: border-color 0.18s ease, background 0.18s ease;\n   }\n   \n   .pc-input:focus {\n     background: rgba(76, 175, 80, 0.05);\n   }\n   \n   .pc-form-complete-banner {\n     padding: 12px 16px;\n     background: rgba(76, 175, 80, 0.10);\n     border: 1px solid rgba(76, 175, 80, 0.28);\n     border-radius: 9px;\n     color: #81c784;\n     font-size: 13px;\n     font-weight: 600;\n     margin-top: 8px;\n   }\n   \n   /* ── Profiles ──────────────────────────────────────────────────────────── */\n   .pc-max-profiles-row {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     margin-bottom: 20px;\n     padding: 14px 16px;\n     background: rgba(255, 255, 255, 0.03);\n     border: 1px solid rgba(255, 255, 255, 0.07);\n     border-radius: 9px;\n   }\n   \n   .pc-stepper {\n     display: flex;\n     align-items: center;\n     gap: 0;\n     border: 1px solid rgba(255, 255, 255, 0.12);\n     border-radius: 8px;\n     overflow: hidden;\n   }\n   \n   .pc-stepper-btn {\n     width: 34px;\n     height: 34px;\n     background: rgba(255, 255, 255, 0.06);\n     border: none;\n     color: rgba(255, 255, 255, 0.70);\n     font-size: 18px;\n     cursor: pointer;\n     transition: background 0.15s ease;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n   }\n   \n   .pc-stepper-btn:hover:not(:disabled) { background: rgba(76, 175, 80, 0.18); color: #4caf50; }\n   .pc-stepper-btn:disabled { opacity: 0.30; cursor: not-allowed; }\n   \n   .pc-stepper-val {\n     min-width: 38px;\n     text-align: center;\n     font-size: 16px;\n     font-weight: 700;\n     color: #fff;\n     background: rgba(255, 255, 255, 0.03);\n     height: 34px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n   }\n   \n   .pc-badge {\n     display: inline-block;\n     font-size: 11px;\n     padding: 2px 8px;\n     border-radius: 20px;\n     background: rgba(76, 175, 80, 0.15);\n     border: 1px solid rgba(76, 175, 80, 0.30);\n     color: #81c784;\n     font-weight: 700;\n     margin-left: 8px;\n     text-transform: none;\n     letter-spacing: 0;\n   }\n   \n   .pc-profile-chips {\n     display: flex;\n     flex-wrap: wrap;\n     gap: 10px;\n     margin-bottom: 16px;\n   }\n   \n   .pc-profile-chip {\n     display: flex;\n     align-items: center;\n     gap: 6px;\n     padding: 9px 16px;\n     background: rgba(255, 255, 255, 0.04);\n     border: 1px solid rgba(255, 255, 255, 0.10);\n     border-radius: 24px;\n     color: rgba(255, 255, 255, 0.70);\n     font-size: 13px;\n     font-weight: 600;\n     cursor: pointer;\n     transition: all 0.18s ease;\n   }\n   \n   .pc-profile-chip:hover:not(.pc-profile-chip--disabled) {\n     background: rgba(76, 175, 80, 0.12);\n     border-color: rgba(76, 175, 80, 0.40);\n     color: #81c784;\n   }\n   \n   .pc-profile-chip--added {\n     background: rgba(76, 175, 80, 0.15) !important;\n     border-color: rgba(76, 175, 80, 0.40) !important;\n     color: #81c784 !important;\n   }\n   \n   .pc-profile-chip--disabled { opacity: 0.35; cursor: not-allowed; }\n   .pc-chip-remove { margin-left: 4px; font-size: 15px; opacity: 0.7; }\n   \n   .pc-selected-profiles { margin-top: 12px; }\n   \n   .pc-selected-profiles-list {\n     display: flex;\n     flex-wrap: wrap;\n     gap: 8px;\n     margin-top: 8px;\n   }\n   \n   .pc-selected-profile-tag {\n     display: flex;\n     align-items: center;\n     gap: 6px;\n     background: rgba(76, 175, 80, 0.12);\n     border: 1px solid rgba(76, 175, 80, 0.28);\n     border-radius: 8px;\n     padding: 7px 12px;\n     font-size: 12.5px;\n     color: #81c784;\n     font-weight: 600;\n   }\n   \n   .pc-remove-profile-btn {\n     background: none;\n     border: none;\n     color: rgba(255, 255, 255, 0.40);\n     font-size: 16px;\n     cursor: pointer;\n     padding: 0 0 0 4px;\n     line-height: 1;\n     transition: color 0.15s ease;\n   }\n   \n   .pc-remove-profile-btn:hover { color: #f44336; }\n   \n   /* ── Radio cards ───────────────────────────────────────────────────────── */\n   .pc-radio-group {\n     display: flex;\n     flex-direction: column;\n     gap: 10px;\n   }\n   \n   .pc-radio-card {\n     display: flex;\n     align-items: center;\n     gap: 14px;\n     padding: 14px 16px;\n     background: rgba(255, 255, 255, 0.02);\n     border: 1px solid rgba(255, 255, 255, 0.08);\n     border-radius: 10px;\n     cursor: pointer;\n     transition: all 0.18s ease;\n     width: 100%;\n     box-sizing: border-box;\n     text-align: left;\n   }\n   \n   .pc-radio-card:hover { border-color: rgba(76, 175, 80, 0.35); background: rgba(76, 175, 80, 0.04); }\n   \n   .pc-radio-card--selected {\n     border-color: rgba(76, 175, 80, 0.40) !important;\n     background: rgba(76, 175, 80, 0.07) !important;\n   }\n   \n   .pc-radio-card-icon { font-size: 1.4rem; flex-shrink: 0; width: 28px; text-align: center; }\n   \n   .pc-radio-card-info { flex: 1; display: flex; flex-direction: column; gap: 3px; }\n   \n   .pc-radio-card-label { font-size: 13.5px; font-weight: 700; color: rgba(255, 255, 255, 0.88); }\n   .pc-radio-card-desc  { font-size: 12px; color: rgba(255, 255, 255, 0.38); line-height: 1.5; }\n   \n   .pc-radio-dot {\n     width: 18px;\n     height: 18px;\n     border-radius: 50%;\n     border: 2px solid rgba(255, 255, 255, 0.22);\n     flex-shrink: 0;\n     transition: background 0.18s ease, border-color 0.18s ease;\n   }\n   \n   /* ── Toggle rows ───────────────────────────────────────────────────────── */\n   .pc-toggle-row {\n     display: flex;\n     align-items: center;\n     gap: 14px;\n     padding: 14px 0;\n     border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n   }\n   \n   .pc-toggle-row--disabled { opacity: 0.45; }\n   \n   .pc-toggle-icon { font-size: 1.3rem; flex-shrink: 0; width: 28px; text-align: center; }\n   \n   .pc-toggle-info { flex: 1; display: flex; flex-direction: column; gap: 3px; }\n   \n   .pc-toggle-label { font-size: 13.5px; font-weight: 600; color: rgba(255, 255, 255, 0.82); }\n   .pc-toggle-desc  { font-size: 12px; color: rgba(255, 255, 255, 0.36); line-height: 1.5; }\n   \n   .pc-filter-grid, .pc-perms-grid { display: flex; flex-direction: column; }\n   \n   .pc-switch--disabled { cursor: not-allowed; opacity: 0.50; }\n   \n   /* ── Subscription warning ──────────────────────────────────────────────── */\n   .pc-subscription-warning {\n     display: flex;\n     align-items: flex-start;\n     gap: 14px;\n     background: rgba(244, 67, 54, 0.08);\n     border: 1px solid rgba(244, 67, 54, 0.22);\n     border-radius: 10px;\n     padding: 16px 18px;\n     margin-top: 20px;\n   }\n   \n   .pc-sub-warn-icon { font-size: 1.8rem; flex-shrink: 0; }\n   \n   .pc-sub-warn-title {\n     font-size: 13.5px;\n     font-weight: 700;\n     color: #ef9a9a;\n     margin: 0 0 5px 0;\n     padding: 0;\n   }\n   \n   .pc-sub-warn-desc {\n     font-size: 12px;\n     color: rgba(255, 255, 255, 0.45);\n     margin: 0;\n     padding: 0;\n     line-height: 1.65;\n   }\n   \n   /* ── Created accounts list ─────────────────────────────────────────────── */\n   .pc-empty-accounts {\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     gap: 10px;\n     padding: 40px 20px;\n     color: rgba(255, 255, 255, 0.38);\n     font-size: 14px;\n   }\n   \n   .pc-accounts-list {\n     display: flex;\n     flex-direction: column;\n     gap: 16px;\n   }\n   \n   .pc-account-card {\n     background: rgba(255, 255, 255, 0.025);\n     border: 1px solid rgba(255, 255, 255, 0.08);\n     border-radius: 12px;\n     overflow: hidden;\n   }\n   \n   .pc-account-card-header {\n     display: flex;\n     align-items: center;\n     gap: 12px;\n     padding: 14px 18px;\n     background: rgba(76, 175, 80, 0.06);\n     border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n   }\n   \n   .pc-account-avatar { font-size: 1.8rem; flex-shrink: 0; }\n   \n   .pc-account-card-info { flex: 1; display: flex; flex-direction: column; gap: 2px; }\n   \n   .pc-account-name { font-size: 14px; font-weight: 700; color: #fff; }\n   .pc-account-uid  { font-size: 12px; color: rgba(255, 255, 255, 0.42); font-family: monospace; }\n   \n   .pc-account-linked-badge {\n     font-size: 11px;\n     font-weight: 700;\n     padding: 4px 10px;\n     border-radius: 20px;\n     background: rgba(76, 175, 80, 0.14);\n     border: 1px solid rgba(76, 175, 80, 0.28);\n     color: #81c784;\n   }\n   \n   .pc-account-card-details {\n     padding: 14px 18px;\n     display: flex;\n     flex-direction: column;\n     gap: 8px;\n   }\n   \n   .pc-account-detail-row {\n     display: flex;\n     align-items: center;\n     gap: 12px;\n     font-size: 13px;\n   }\n   \n   .pc-detail-key {\n     min-width: 130px;\n     color: rgba(255, 255, 255, 0.40);\n     font-size: 12px;\n     font-weight: 600;\n   }\n   \n   .pc-detail-val { color: rgba(255, 255, 255, 0.75); font-size: 12.5px; }\n   \n   .pc-account-login-hint {\n     display: flex;\n     align-items: center;\n     gap: 8px;\n     padding: 10px 18px;\n     background: rgba(33, 150, 243, 0.07);\n     border-top: 1px solid rgba(33, 150, 243, 0.15);\n     font-size: 12px;\n     color: rgba(255, 255, 255, 0.50);\n   }\n   \n   .pc-account-login-hint strong { color: #64b5f6; font-family: monospace; }\n   \n   /* ── Toast ─────────────────────────────────────────────────────────────── */\n   .pc-toast {\n     display: flex;\n     align-items: flex-start;\n     justify-content: space-between;\n     gap: 12px;\n     padding: 13px 18px;\n     border-radius: 10px;\n     font-size: 13.5px;\n     font-weight: 600;\n     margin-bottom: 20px;\n     animation: pc-fadeIn 0.2s ease;\n   }\n   \n   .pc-toast--success { background: rgba(76,175,80,0.12); border: 1px solid rgba(76,175,80,0.30); color: #81c784; }\n   .pc-toast--warning { background: rgba(255,152,0,0.10); border: 1px solid rgba(255,152,0,0.28); color: #ffb74d; }\n   .pc-toast--error   { background: rgba(244,67,54,0.10); border: 1px solid rgba(244,67,54,0.28); color: #ef9a9a; }\n   \n   .pc-toast-close {\n     background: none;\n     border: none;\n     color: inherit;\n     opacity: 0.6;\n     font-size: 20px;\n     cursor: pointer;\n     line-height: 1;\n     flex-shrink: 0;\n   }\n   \n   /* ── Action bar ────────────────────────────────────────────────────────── */\n   .pc-action-bar {\n     display: flex;\n     align-items: center;\n     gap: 12px;\n     padding-top: 20px;\n     margin-top: 8px;\n     border-top: 1px solid rgba(255, 255, 255, 0.07);\n   }\n   \n   .pc-reset-btn {\n     background: black;\n     border: 1px solid rgba(255, 255, 255, 0.10);\n     color: white;\n     border-radius: 9px;\n     padding: 11px 22px;\n     font-size: 13px;\n     font-weight: 700;\n     cursor: pointer;\n     transition: background 0.15s ease;\n   }\n   \n   .pc-reset-btn:hover { background: rgba(255, 255, 255, 0.10); color: rgba(255,255,255,0.80); }\n   \n   .pc-submit-btn { align-self: flex-start; }\n   \n   /* ── Responsive ────────────────────────────────────────────────────────── */\n   @media (max-width: 768px) {\n     .pc-form-grid       { grid-template-columns: 1fr; }\n     .pc-inner-tab       { font-size: 11.5px; padding: 9px 11px; }\n     .pc-action-bar      { flex-direction: column; align-items: stretch; }\n     .pc-reset-btn,\n     .pc-submit-btn      { width: 100%; text-align: center; }\n     .pc-master-toggle   { flex-direction: column; align-items: flex-start; }\n   }\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
